export enum InternetKeychain {
  RefreshToken = 'refreshToken',
  AccessToken = 'accessToken',
  RecordPassphrase = 'recordPassphrase',
  IapPassphrase = 'iapPassphrase',
  UploadPassphrase = 'uploadPassphrase',
}
